import React from "react";
import styles from "./WorldNewsSection.module.scss";
import newsImage from "../../../assets/images/news-image.jpg";

const WorldNewsSection = () => {
  return (
    <div className={styles.worldNewsSectionContainer}>
      <h1 className={styles.mainTitle}>World News</h1>
      <div className={styles.worldNewsList}>
        <div className={styles.card}>
          <div className={styles.image}>
            <img src={newsImage} alt="The Title Of The News" />
          </div>
          <div className={styles.info}>
            <h2 className={styles.title} title="The Title Of The News">
              The Title Of The News
            </h2>
            <div className={styles.date}>Nov 24, 2024</div>
            <p className={styles.desc}>
              Contrary to popular belief, Lorem Ipsum is not simply random text.
              It has roots in a piece of classical Latin literature from 45
              BC...
              <span>Read more</span>
            </p>
          </div>
        </div>
        <div className={styles.card}>
          <div className={styles.image}>
            <img src={newsImage} alt="The Title Of The News" />
          </div>
          <div className={styles.info}>
            <h2 className={styles.title} title="The Title Of The News">
              The Title Of The News
            </h2>
            <div className={styles.date}>Nov 24, 2024</div>
            <p className={styles.desc}>
              Contrary to popular belief, Lorem Ipsum is not simply random text.
              It has roots in a piece of classical Latin literature from 45
              BC...
              <span>Read more</span>
            </p>
          </div>
        </div>
        <div className={styles.card}>
          <div className={styles.image}>
            <img src={newsImage} alt="The Title Of The News" />
          </div>
          <div className={styles.info}>
            <h2 className={styles.title} title="The Title Of The News">
              The Title Of The News
            </h2>
            <div className={styles.date}>Nov 24, 2024</div>
            <p className={styles.desc}>
              Contrary to popular belief, Lorem Ipsum is not simply random text.
              It has roots in a piece of classical Latin literature from 45
              BC...
              <span>Read more</span>
            </p>
          </div>
        </div>
      </div>

      <div className={styles.viewAllCentered}>View All</div>
    </div>
  );
};

export default WorldNewsSection;
